import UserPermission from '@users/user/UserPermission';
import CheckAccessPermissions from '@users/session/CheckAccessPermissions';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import UserProfileMenu from '@/creditflowresearch/ui/common/components/organisms/UserProfileMenu';
import UserProfileFallback from '@/creditflowresearch/ui/common/components/organisms/UserProfileFallback';

import styles from './userProfileTemplate.module.scss';

const preloader = (
  <div className={ styles.logInBtnSpinnerWrapper }>
    <Spinner color="on-color" className={ styles.logInBtnSpinner } />
  </div>
);

const UserProfileTemplate = () => (
  <CheckAccessPermissions
    permissions={ UserPermission.managerAccess }
    fallback={ <UserProfileFallback /> }
    preloader={ preloader }
  >
    <UserProfileMenu />
  </CheckAccessPermissions>
  );

export default UserProfileTemplate;
